import { render, staticRenderFns } from "./worklog-form.vue?vue&type=template&id=72a9f08b&"
import script from "./worklog-form.vue?vue&type=script&lang=js&"
export * from "./worklog-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports